import React, { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, FileSearch, ShieldOff, X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import FrDateField from "@/components/FrDateField";

// Admin : vérification d'un nouveau véhicule (carte grise + assurance).
export default function VehicleReviewDialog({ row, onClose, onDone }) {
  const [form, setForm] = useState({ carte_grise_issued_at: "", insurance_expires_at: "", insurance_next_check_at: "" });
  const [reason, setReason] = useState("");
  const [preview, setPreview] = useState(null);
  const base = `/admin/price/vehicles/${row.user_id}/${row.vehicle_id}`;
  const view = async (kind) => {
    try { const { data } = await api.get(`${base}/file/${kind}`); setPreview(data); } catch (e) { toast.error(formatApiError(e)); }
  };
  const call = async (path, body, msg) => {
    try { await api.post(`${base}/${path}`, body); toast.success(msg); onDone(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="fixed inset-0 z-[90] grid place-items-center bg-black/50 p-4" data-testid="vehicle-review-dialog">
      <div className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-3xl bg-white p-5 street-border street-shadow">
        <div className="flex items-start justify-between gap-2">
          <div><div className="font-[Outfit] text-xl font-black">{row.name}</div><div className="text-[12px] font-semibold text-foreground/60">Nouveau véhicule : {row.vehicle}</div></div>
          <button type="button" onClick={onClose} data-testid="vehicle-review-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="mt-3 flex gap-1.5">
          {[["carte_grise", "Carte grise"], ["insurance", "Assurance"]].map(([k, l]) => (
            <button key={k} type="button" onClick={() => view(k)} className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1.5 text-[12px] font-black street-border-thin" data-testid={`vehicle-review-view-${k}`}>
              <FileSearch className="h-3.5 w-3.5" />Voir {l}
            </button>
          ))}
        </div>
        {preview && (preview.data ? (
          preview.mime_type === "application/pdf"
            ? <a className="mt-2 block text-sm font-black underline" href={`data:application/pdf;base64,${preview.data}`} download={preview.filename}>Télécharger le PDF</a>
            : <img alt="document" className="mt-2 max-h-64 rounded-xl street-border-thin" src={`data:${preview.mime_type};base64,${preview.data}`} />
        ) : <p className="mt-2 text-sm text-red-700">{preview.error || "Indisponible"}</p>)}
        <div className="mt-4 grid grid-cols-3 items-end gap-2">
          {[["carte_grise_issued_at", "Carte grise : délivrance"], ["insurance_expires_at", "Assurance : expiration"], ["insurance_next_check_at", "Assurance : prochain contrôle"]].map(([k, l]) => (
            <label key={k} className="text-[11px] font-black uppercase">{l}
              <div className="mt-1"><FrDateField value={form[k]} onChange={(v) => setForm({ ...form, [k]: v })} testid={`vehicle-review-${k}`} /></div>
            </label>
          ))}
        </div>
        <p className="mt-1 text-[11px] font-semibold text-foreground/60">Sans date saisie, prochain contrôle de l&apos;assurance = validation + 12 mois. Un Mémo Véhicule Assuré peut être accepté.</p>
        <button type="button" onClick={() => call("validate", Object.fromEntries(Object.entries(form).filter(([, v]) => v)), "Véhicule validé")}
          className="mt-3 flex h-11 w-full items-center justify-center gap-2 rounded-full bg-emerald-500 font-black text-white street-border" data-testid="vehicle-review-validate">
          <CheckCircle2 className="h-4 w-4" />Valider le véhicule
        </button>
        <textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motif du refus" className="mt-3 h-20 w-full rounded-xl p-2 text-[13px] street-border-thin" data-testid="vehicle-review-reason" />
        <button type="button" onClick={() => call("reject", { reason }, "Véhicule refusé")}
          className="mt-2 flex h-10 w-full items-center justify-center gap-2 rounded-full bg-red-100 text-[13px] font-black street-border-thin" data-testid="vehicle-review-reject">
          <ShieldOff className="h-4 w-4" />Refuser
        </button>
      </div>
    </div>
  );
}
